// extracted by mini-css-extract-plugin
export default {"burger_menu":"BurgerMenu_burger_menu__TbzZs","menu_open":"BurgerMenu_menu_open__rheO+"};